export default __webpack_public_path__ + "static/media/rug13-min.ad39c296.jpg";